import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class TagServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }
  public getAllList(opts: object) {
    const url = serverUrl + '/api/sysManage/tagManage/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  public getTreeAllList(opts: object) {
    const url = serverUrl + '/api/sysManage/tagManage/list/all/tree';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public get(id: string) {
    return this.rSerivce.serverObj.request({
      method: 'get',
      url: serverUrl + `/api/sysManage/tagManage/${id}`,
    });
  }

  public getTreeList(params: any = {}) {
    return this.rSerivce.serverObj.request({
      method: 'get',
      url: serverUrl + '/api/sysManage/tagManage/list/page/tree',
      params: params,
    });
  }

  public getList(params: any = {}) {
    return this.rSerivce.serverObj.request({
      method: 'get',
      url: serverUrl + '/api/sysManage/tagManage',
      params: params,
    });
  }

  public add(
    params: any = {
      tagList: [],
    },
  ) {
    return this.rSerivce.serverObj.request({
      method: 'post',
      url: serverUrl + `/api/sysManage/tagManage`,
      data: params,
    });
  }

  public edit(
    params = {
      id: '',
      pid: null,
      type: '',
      name: '',
      sort: '',
    },
  ) {
    return this.rSerivce.serverObj.request({
      method: 'put',
      url: serverUrl + `/api/sysManage/tagManage`,
      data: params || '',
    });
  }

  public remove(ids: string | string[]) {
    if (ids instanceof Array) ids = ids.join(',');
    return this.rSerivce.serverObj.request({
      method: 'delete',
      url: serverUrl + `/api/sysManage/tagManage`,
      params: {
        idList: ids,
      },
    });
  }
}
